import React, { useEffect, useState } from "react";
import { RotateCcw, RotateCw, Undo2 } from "lucide-react";

export const normDeg = (v) => (((Math.round(Number(v) * 10) / 10) % 360) + 360) % 360;
export const snapDeg = (v, step = 45) => normDeg(Math.round(normDeg(v) / step) * step);

export function RotationControl({ value = 0, onChange }) {
  const [text, setText] = useState(String(normDeg(value)));
  const [snap, setSnap] = useState(false);
  useEffect(() => { setText(String(normDeg(value))); }, [value]);
  const set = (deg) => onChange(normDeg(deg));
  const commit = () => { const n = parseFloat(text); if (Number.isFinite(n)) set(n); else setText(String(normDeg(value))); };
  const slide = (v) => set(snap ? snapDeg(v) : v);
  const cls = "w-8 h-8 flex items-center justify-center text-white/70 hover:text-pgt-green disabled:opacity-30";
  return (
    <div className="flex items-center gap-1" data-testid="rotation-control">
      <button onClick={() => set(value - 90)} title="Rotate −90°" data-testid="obj-rotate-ccw90" className={cls}><RotateCcw size={16} /></button>
      <input type="number" step="any" value={text} onChange={(e) => setText(e.target.value)} onBlur={commit}
        onKeyDown={(e) => { if (e.key === "Enter") { commit(); e.currentTarget.blur(); } }}
        className="w-16 h-8 bg-pgt-bg border border-white/15 rounded-sm px-1 text-center text-xs text-white outline-none focus:border-pgt-green" aria-label="Rotation in degrees" data-testid="obj-rotate-input" />
      <span className="text-[11px] text-white/50 -ml-0.5">°</span>
      <button onClick={() => set(value + 90)} title="Rotate +90°" data-testid="obj-rotate90" className={cls}><RotateCw size={16} /></button>
      <button onClick={() => set(0)} disabled={normDeg(value) === 0} title="Reset rotation to 0°" data-testid="obj-rotate-reset" className={cls}><Undo2 size={14} /></button>
      <input type="range" min="0" max="359" step={snap ? 45 : 1} value={Math.round(normDeg(value))} onChange={(e) => slide(parseInt(e.target.value, 10))} className="w-20 mx-1" data-testid="obj-rotate-slider" />
      <label className="flex items-center gap-1 text-[10px] text-white/50 cursor-pointer select-none" title="Snap slider to 45° steps">
        <input type="checkbox" checked={snap} onChange={(e) => setSnap(e.target.checked)} className="accent-pgt-green" data-testid="obj-rotate-snap" /> Snap
      </label>
    </div>
  );
}
